import { Box, Stack } from '@mui/material';
import classNames from 'classnames/bind';
import ButtonElement from '@/views/elements/button/ButtonElement';

import styles from '../../Unauthorized/ModalRegisterMasterFollower.module.scss';
import { ReactComponent as Success } from '../../../../assets/icons/Success.svg';
import TypographyElement from '@/views/elements/typography/TypographyElement';
import { useTranslation } from 'react-i18next';

const cx = classNames.bind(styles);

export type PropsStep = {
    close: () => void,
}

const Step3 = ({ close }: PropsStep) => {
    const { t } = useTranslation()
    return (
        <Box>
            <Stack
                direction={"column"}
                spacing={2}
                justifyContent={"center"}
                alignItems={"center"}
            >
                <Box pt={2}>
                    <Success />
                </Box>

                <TypographyElement id="modal-modal-title" TextAlignElement='center' FontSizeElement='18px' FontWeightElement={700} ColorElement='primary' pb={1} >
                    {t("copytrade.common.success")}
                </TypographyElement>

                <Stack
                    direction={"row"}
                    spacing={2}
                    justifyContent={"center"}
                    width={"100%"}
                >
                    <ButtonElement customType="Primary" className={cx("btn-register")} variant="contained"
                        onClick={close} >{t("copytrade.common.done")}</ButtonElement>
                </Stack>
            </Stack>
        </Box >
    )
}

export default Step3